// LIVE-PRODUCT-VIDEO-MANUAL-GENERATE-FIX-1 · 수동 '영상 생성' 가능 여부 (서버 needs_work 와 같은 기준 · 서버 검증은 그대로).
export const MAX_ATTEMPTS = 3;

export const videoGenState = (video, cancelled = false) => {
  if (cancelled) return { can: false, reason: '취소된 소개 구간입니다.' };
  const st = video?.status ?? null;
  if (st === null || st === 'PENDING') return { can: true, reason: '영상 생성 가능 · 방송 원본 저장 완료 후 생성됩니다.' };
  if (st === 'STALE') return { can: true, reason: '구간이 변경되어 새 버전 생성이 필요합니다.' };
  if (st === 'HELD') return { can: true, reason: '처리 보류 상태 · 구간을 확인한 뒤 다시 생성할 수 있습니다.' };
  if (st === 'PROCESSING') return { can: false, reason: '상품 소개영상을 생성하고 있습니다.' };
  if (st === 'READY') return { can: false, reason: '소개영상이 준비되었습니다.' };
  if (st === 'FAILED') {
    return Number(video?.attempts || 0) < MAX_ATTEMPTS
      ? { can: true, reason: '생성 실패 · 다시 시도할 수 있습니다.' }
      : { can: false, reason: '생성 실패 · 재시도 한도를 초과했습니다.' };
  }
  return { can: false, reason: '영상 생성을 할 수 없는 상태입니다.' };
};
